import { isGovUser } from '@govinity/validation';
import { useAuthStore } from '@/stores/authStore';

/**
 * System admins of the portal's government can open pages hidden via `navHiddenElements`,
 * mirroring who can change those settings in the public portal settings admin page.
 */
export function useCanPreviewHiddenPortalPages(governmentId: number | undefined): boolean {
  const user = useAuthStore((state) => state.user);

  if (!user || !isGovUser(user) || user.governmentId !== governmentId) {
    return false;
  }

  return user.roles.some((role) => role.isSystemAdmin);
}
